import React from 'react'

import { DotLoader } from 'react-spinners';

export default () => {
  return <DotLoader color = {'#124AC7'} size = {60} />
}
